/** Standard rule for the Name field — required and non-whitespace. The same
 *  check powers the standalone action detail page, the node-agent action
 *  inspector, and the Transfer edit body. */
export function validateName(name) {
    const nameError = name.trim().length === 0;
    return { nameError, issue: nameError ? 'Name is required' : null };
}
/** TRANSFER-specific recipient check used by TransferEditBody. Not relevant
 *  to the row-list form, so it lives next to validateName rather than inside
 *  the main catalog validator. */
export function validateTransferParameters(parameters) {
    if (parameters.recipients.length === 0) {
        return { issue: 'Add at least one recipient' };
    }
    if (parameters.recipients.some(r => !r.number.trim())) {
        return { issue: 'Every recipient needs a phone number' };
    }
    return { issue: null };
}
//# sourceMappingURL=action-validators.js.map